










import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomIconDisk extends ComponentVue {
  @Prop({ type: Boolean, default: false })
  active!: boolean
}
